<template>
  <div class="feet-r">
    <el-button
      icon="el-icon-download"
      size="small"
      type="primary"
      @click="operationBtn"
    >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
    <upload-excel
      :on-success="importLogistics"
      :but-name="$t('basicData.ImportAddRegion')"
    />
  </div>
</template>

<script>
import { apiAreaImportAdd } from '@/api/finance/basicData';
import { saveAs } from 'file-saver';
const ExcelJS = require('exceljs');
import uploadExcel from '@/components/UploadExcel';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';

export default {
  name: 'ImportArea',
  components: {
    uploadExcel
  },
  mixins: [toolRequestClass],
  props: {
    regionalLevelOption: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      errData: []
    };
  },
  methods: {
    // 下载模板
    operationBtn() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2');
        Sheet1.columns = [
          {
            header: '*IBGE代码',
            key: 'ibge',
            width: 40
          },
          {
            header: '州二字码',
            key: 'twoCode',
            width: 20
          },
          {
            header: '城市',
            key: 'cName',
            width: 20
          },
          {
            header: '邮编',
            key: 'zipCode',
            width: 50
          },
          {
            header: '区域层级',
            key: 'regionalLevel',
            width: 20
          },
          {
            header: 'ISS税率(%)',
            key: 'issTaxation',
            width: 20
          }
        ];
        const headerRow = Sheet1.getRow(1);
        headerRow.font = { bold: true }; // 加粗
        headerRow.alignment = { vertical: 'middle' };
        headerRow.height = 28;

        Sheet1.mergeCells('A2:F2');
        const noteCell = Sheet1.getCell('A2');
        noteCell.value = `
      一：IBGE代码必填，其他非必填；
      二：导入数据时校验IBGE代码是否已存在；
      1）若IBGE已存在；
      *若未维护其他非必填字段，则不更新数据；
      *若维护了其他非必填字段，则根据IBGE覆盖更新（比如只维护了邮编，则导入成功后，只更新这个IBGE的邮编数据，其他字段不更新）；
      2）若IBGE不存在；
      *校验州二字码、城市、邮编三者必填，若校验成功，则根据导入数据生成一条新的地区数据`;
        // ---------- 样式2：说明文本换行 ----------
        noteCell.alignment = { wrapText: true, horizontal: 'left' };
        // noteCell.font = { size: 10, color: { argb: 'FF475569' }, italic: true };
        // 可选：设置说明行行高
        Sheet1.getRow(2).height = 100; // 根据内容调整

        Sheet2.columns = [
          {
            header: '区域层级', // 账号类型
            key: 'regionalLevel',
            width: 40
          }
        ];
        const Sheet2_data = [];
        that.regionalLevelOption.map(item => {
          Sheet2_data.push({
            regionalLevel: item.label + '->' + item.value,
            width: 20
          });
        });
        Sheet2.addRows(Sheet2_data);
        new Array(2000).fill(0).forEach((_, idx) => {
          const row = idx + 2;
          // 区域层级
          Sheet1.getCell(row, 5).dataValidation = {
            type: 'list',
            formulae: [`=Sheet2!$A$2:$A${Sheet2_data.length + 1}`]
          };
        });
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.$t('basicData.ImportAddRegion') + '.xlsx';
        saveAs(blob, saveName);
      }
      ddd();
    },
    // 导入费用
    importLogistics(array) {
      const dataArr = [];
      const arrData = array[0].results.splice(1);
      const logisticsKey = {
        '*IBGE代码': 'ibge',
        '州二字码': 'twoCode',
        '城市': 'cName',
        '邮编': 'zipCode',
        '区域层级': 'regionalLevel',
        'ISS税率(%)': 'issTaxation'
      };
      arrData.map((item) => {
        const dataObj = {};
        for (const k in logisticsKey) {
          if (item[k]) {
            if (k === '区域层级') {
              dataObj[logisticsKey[k]] = item[k].split('->')[1];
            } else {
              dataObj[logisticsKey[k]] = item[k];
            }
          } else {
            dataObj[logisticsKey[k]] = '';
          }
        }
        dataArr.push(dataObj);
      });
      const param = [];
      this.errData = {};
      // const errCode = [];
      dataArr.map((item, ind) => {
        const obj = {
          parentNode: {
            twoCode: item.twoCode
          },
          ibge: item.ibge,
          name: item.cName,
          zipCode: item.zipCode,
          regionalLevel: item.regionalLevel,
          issTaxation: item.issTaxation
        };
        param.push(obj);
      });
      apiAreaImportAdd(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.getAllState({ level: 1, parentId: '' });
          this.getAllState({ level: 2, parentId: '' });
          this.$emit('importChange');
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
